export const fireLinkedinBookADemoEvent = (): void => {
  window.lintrk?.('track', { conversion_id: 8723714 })
}

export const fireLinkedinProSubmitPaymentEvent = (): void => {
  window.lintrk?.('track', { conversion_id: 8723722 })
}

export const fireLinkedinCreateAccountEvent = (): void => {
  window.lintrk?.('track', { conversion_id: 8723730 })
}

export const fireLinkedinHomePageCreateAFlowcodeEvent = (): void => {
  window.lintrk?.('track', { conversion_id: 9885484 })
}

export const fireLinkedinHomePageConnectWithUsEvent = (): void => {
  window.lintrk?.('track', { conversion_id: 9885468 })
}
